import { render, staticRenderFns } from "./ButtonToggleCart.vue?vue&type=template&id=4b6776ee"
import script from "./ButtonToggleCart.vue?vue&type=script&lang=js"
export * from "./ButtonToggleCart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports